<template>
  <div class="demo-new-design">
    <div class="ws-header">
      <div class="container ws-header__inner">
        <img class="ws-logo" src="../../../public/logo.png" alt="" srcset="" />
      </div>
    </div>
    <nav class="ws-nav">
      <div class="container ws-nav__inner">
        <i class="fa fa-chevron-left" style="line-height: 1.1875rem"></i>
        <p class="ws-nav__title" style="margin-left: 0.25rem">Meal plan</p>
      </div>
    </nav>
    <div class="container">
      <div class="ws-block">
        <span class="ws-block__index">1</span>
        <h2 class="ws-block__title" style="margin-bottom: 0.375rem">Text boxes</h2>
        <div class="ws-textbox">
          <p class="ws-text">{{ textarea }}</p>
        </div>
      </div>
      <div class="ws-block">
        <span class="ws-block__index">2</span>
        <h2 class="ws-block__title" style="margin-bottom: 0.375rem">Titles</h2>
        <div class="ws-textbox">
          <h3 class="ws-title">Titles</h3>
        </div>
      </div>
      <div class="ws-block">
        <span class="ws-block__index">3</span>
        <h2 class="ws-block__title" style="margin-bottom: 0.375rem">Buttons</h2>
        <div>
          <p class="ws-block__item">---- 1 Button</p>
          <div style="margin: 1rem">
            <button class="ws-btn">Book</button>
            <br />
            <button class="ws-btn space-button">Cancel</button>
            <br />
            <button class="ws-btn space-button">Proceed</button>
          </div>
        </div>
        <div>
          <p class="ws-block__item">---- 2 Buttons</p>
          <div style="margin: 0.5rem; display: flex; flex-wrap: wrap">
            <div style="padding: 0.5rem">
              <button class="ws-btn ws-btn--cancel">Cancel</button>
            </div>
            <div style="padding: 0.5rem">
              <button class="ws-btn">Proceed</button>
            </div>
          </div>
        </div>
      </div>
      <div class="ws-block">
        <span class="ws-block__index">4</span>
        <h2 class="ws-block__title" style="margin-bottom: 0.375rem">Pop ups</h2>
        <div>
          <button class="ws-btn" @click="isOpen = !isOpen">Show Popups</button>
          <b-modal v-model="isOpen" :modal-class="'ws-modal'" centered>
            <div></div>
            <template #modal-footer>
              <div class="ws-modal__footer w-100">
                <button class="ws-btn ws-btn--cancel" @click="isOpen = !isOpen">Cancel</button>
                <button class="ws-btn" @click="isOpen = !isOpen">Proceed</button>
              </div>
            </template>
          </b-modal>
        </div>
      </div>
      <div class="ws-block">
        <span class="ws-block__index">5</span>
        <h2 class="ws-block__title" style="margin-bottom: 0.375rem">SELECTORS</h2>
        <div>
          <p class="ws-block__item">---- Checkboxes</p>
          <div style="margin: 1rem">
            <label class="ws-checkbox-container">
              <input type="checkbox" />
              <span class="ws-checkbox-container__checkmark"></span>
              <span class="ws-checkbox-container__name">Unchecked </span>
            </label>
            <label class="ws-checkbox-container">
              <input type="checkbox" />
              <span class="ws-checkbox-container__checkmark"></span>
              <span class="ws-checkbox-container__name">Hover to see </span>
            </label>
            <label class="ws-checkbox-container">
              <input type="checkbox" checked="checked" />
              <span class="ws-checkbox-container__checkmark"></span>
              <span class="ws-checkbox-container__name">Checked </span>
            </label>
          </div>
        </div>
        <div>
          <p class="ws-block__item">---- Radio Button</p>
          <div style="margin: 1rem">
            <label class="ws-radio-container">
              <input type="radio" name="radio" />
              <span class="ws-radio-container__checkmark"></span>
              <span class="ws-radio-container__name">Unchecked</span>
            </label>
            <label class="ws-radio-container">
              <input type="radio" name="radio" />
              <span class="ws-radio-container__checkmark"></span>
              <span class="ws-radio-container__name">Hover to see</span>
            </label>
            <label class="ws-radio-container">
              <input type="radio" checked="checked" name="radio" />
              <span class="ws-radio-container__checkmark"></span>
              <span class="ws-radio-container__name">Checked</span>
            </label>
          </div>
        </div>
        <div>
          <p class="ws-block__item">---- Toggle Button</p>
          <div style="margin: 1rem">
            <div style="margin-bottom: 0.5rem">
              <label class="ws-switch-container">
                <input type="checkbox" />
                <span class="ws-switch-container__slider ws-switch-container__slider--round"></span>
              </label>
            </div>
            <div>
              <label class="ws-switch-container">
                <input type="checkbox" checked />
                <span class="ws-switch-container__slider ws-switch-container__slider--round"></span>
              </label>
            </div>
          </div>
        </div>
        <div>
          <p class="ws-block__item">---- Drop Down</p>
          <div style="margin: 1rem">
            <v-select
              class="ws-drop-down ws-drop-down--desktop"
              placeholder="Options"
              :clearable="false"
              :searchable="false"
              :filterable="false"
              :options="optionSelect"
            ></v-select>
          </div>
        </div>
      </div>
      <div class="ws-block">
        <span class="ws-block__index">6</span>
        <h2 class="ws-block__title" style="margin-bottom: 0.375rem">Progress bar</h2>
        <div class="ws-textbox ws-progress-bar-box">
          <div class="ws-progress-bar-container ws-progress-bar-container--desktop">
            <div class="ws-progress-bar" :style="{ width: `${progressBarWidth}%` }"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="ws-footer">
      <div class="container ws-footer__inner">
        <p class="ws-footer__text">powered by Stranded Flight Solutions</p>
        <p class="ws-footer__text">v.13</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
      optionSelect: ['Option 1', 'Option 2', 'Option 3', 'Option 4'],
      textarea:
        'Pick one of the following hotels Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
      progressBarWidth: 10,
      setIntervalId: null
    }
  },

  mounted() {
    this.onRunProgressBar()
  },

  beforeUnmount() {
    clearInterval(this.setIntervalId)
  },

  methods: {
    onRunProgressBar() {
      const self = this
      this.setIntervalId = setInterval(function () {
        if (self.progressBarWidth >= 100) {
          self.progressBarWidth = 0
        }
        self.progressBarWidth = self.progressBarWidth + 1
      }, 50)
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/global/demo-new-design.scss';
</style>
